import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
//https://medium.com/@jkeung/integrating-google-maps-api-w-angular-7-e7672396ce2d
//https://dev.to/devpato/setup-google-map-in-angular-app-the-pro-way-3m9p
//https://timdeschryver.dev/blog/google-maps-as-an-angular-component

//https://timdeschryver.dev/blog/google-maps-as-an-angular-component
//https://www.geeksforgeeks.org/how-to-add-google-map-and-marker-to-your-application-using-angularjs/
//https://morioh.com/p/11d933ad6801


@Component({
  selector: 'app-custom-gmaps-main',
  templateUrl: './custom-gmaps-main.component.html',
  styleUrls: ['./custom-gmaps-main.component.scss']
})
export class CustomGmapsMainComponent implements OnInit {
  baseUrl: string;
  url: string;

  constructor() {
    this.baseUrl = environment.urlAddress + '/api/';
  }

  ngOnInit() { }
}
